export class BaseLookup {
    id: string;
    name: string;
    abrv: string;
}